import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Container
} from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

export default function SurveyDisqualified() {
  const navigate = useNavigate();
  const { surveyId } = useParams();
  const location = useLocation();
  
  // Get custom reason from navigation state
  const customReason = location.state?.reason;
  
  // Default message if no custom reason provided
  const defaultMessage = 'Извините, исходя из Вашего ответа Вы не подходите для этого опроса.';

  const handleContinue = () => {
    navigate('/respondent/dashboard');
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <InfoIcon 
            color="warning" 
            sx={{ fontSize: 80, mb: 3 }} 
          />
          
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mb: 2 }}>
            Благодарим за участие!
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
            {customReason || defaultMessage}
            <br />
            <br />
            Пожалуйста, продолжайте проходить другие опросы на платформе!
          </Typography>

          <Button 
            variant="contained" 
            size="large"
            onClick={handleContinue}
            sx={{ mt: 2, px: 4 }}
          >
            Хорошо, понятно
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
